import { useEffect } from 'react'

import { MODE } from '@infraloop/services'
import * as Sentry from '@sentry/react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'

Sentry.init({
  dsn: 'https://cd7c94b756b1e8cb4c0a2fced529fba1@o4505779235454976.ingest.us.sentry.io/4511498872684544',
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    /^\//, // Includes all local routes.
    /3dinfraloop\.app\/v1$/, // Includes all requests to the API.
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysOnErrorSampleRate: 1.0,

  // Set environment
  environment: MODE.toUpperCase(),

  // All 'builds' (yarn build) are production builds. Only local development (yarn start) is considered development.
  // This is to prevent reporting on local development.
  enabled: MODE === 'prod',
})
